import { useRouteOwner } from '@/services/router/route-ownership';
import { useLocation } from '@/services/router/compat';
import { useEffect } from 'react';

/**
 * Marks `document.body` with the framework serving the current route
 * (`data-route-owner="hydra"` for native React routes, `"embedded"` for
 * Journeys/Ember or Design Studio), so the Ember→React migration state is
 * observable in production (where dev tools are unavailable) even while
 * feature flags flip ownership per account.
 */
export function useRouteOwnerBodyAttribute() {
  const { pathname } = useLocation();

  // Reactive: flag-gated entries fall back to `embedded` until the account has
  // loaded, and useRouteOwner re-evaluates when the flags arrive.
  const routeOwner = useRouteOwner(pathname);

  useEffect(() => {
    document.body.dataset.routeOwner = routeOwner;
  }, [routeOwner]);
}
